function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';

/**
 * A React component that is used to render HTML Nodes.
 * Inspired by: https://github.com/Optibus/ember-cli-react/blob/v1.0.2/addon/components/react-component/yield-wrapper.js
 *
 * The primary usage of this component is to support `props.children` in `react-component`.
 * The catch is that if the children is unstable, they need to be wrapped in a stable tag
 * (e.g. div) to make Glimmer happy.
 * See: https://github.com/yapplabs/ember-wormhole/issues/66#issuecomment-263575168
 *
 * Note that although this is possible, it should be used as a tool to migrate Ember to React
 * without the hard requirement to start with leaf components. It is highly recommended to
 * have clean React component tree whenever possible.
 *
 * Integration guide: https://reactjs.org/docs/integrating-with-other-libraries.html
 */

class YieldWrapper extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "el", null);
    _defineProperty(this, "wrapperRef", React.createRef());
  }
  componentDidMount() {
    // Different with the integration guide, we avoid jQuery here
    const fragment = document.createDocumentFragment();
    for (const node of this.props.nodes) {
      fragment.appendChild(node);
    }

    // adding the dom children passed as props to the span element
    // we're inserting instead of replacing the span element so that react can
    // unmount the YieldWrapper and its children automatically when the parent component is unmounted
    const el = this.wrapperRef.current;
    el?.appendChild(fragment);
  }
  render() {
    // This element is temporary. When this is mounted,
    // it will be replaced by the children nodes, handled by Ember.
    return React.createElement('span', {
      ref: this.wrapperRef
    });
  }
}
export default YieldWrapper;